import { Activite, BaseEntite, BaseEntiteStatique, NouvelleEntite } from '../../../../../common/src/entities';
import React, { CSSProperties, FormEvent, ReactElement, ReactNode, useEffect, useRef, useState } from 'react';
import { Formik, FormikHelpers, FormikProps } from 'formik';
import { usePrompt } from 'react-router-dom';
import { Badge, Button, ButtonGroup, DropdownButton, Form, Modal, Spinner } from 'react-bootstrap';
import EnteteDePage from './EnteteDePage';
import { ObjectSchema } from 'yup';
import { BiCheck, BiError } from 'react-icons/all';
import { useAlertDialog } from '../../../Utils/dialogContext';
import BoutonPreSuiv from './BoutonPreSuiv/BoutonPreSuiv';
import api from '../../../Utils/api';

function transformerNomsDesChamps(logs: string, correspondance: { [key: string]: string }): string {
    Object.keys(correspondance).forEach((champFormulaire) => {
        const champBD = correspondance[champFormulaire];
        const regex = new RegExp(`\\b${champFormulaire}\\b`);
        logs = logs.replace(regex, champBD);
    });
    return logs;
}

//À tenir à jour pour la sauvegarde dans la table d'historique de logs
const nomDeTable = {
    clients: 'client',
    fournisseurs: 'fournisseur',
    activites: 'activite',
    contacts: 'contact',
    lieux: 'lieu',
    produits: 'produit',
    ententes: 'ententes',
    'modele-horaire': 'modeles_horaire',
    etiquettes: 'etiquette',
    'centres-service-scolaire': 'css',
    'calendrier-scolaire': 'calendrier',
    categories: 'categorie',
    thematique: 'thematique',
    facturation: 'facturation',
    historique_prix_produit: 'historique_prix_produit',
    'modele-courriel': 'modeles_courriel',
};

//À tenir à jour pour sauvegarder le nom du champs du formualaire au lieu d'enregistrer le id.
// id: "titre".
const champCorrespondance = {
    priorite: 'Priorite',
    image_principale: 'Image Principale',
    fournisseur: 'Fournisseur',
    actif: 'Actif',
    taxable: 'Taxable',
    ficav: 'FICAV',
    signer_contrat: 'Contrat requis',
    public_date_echeance: `Date d'échéance`,
    public: `Publique jusqu'au`,
    name: 'Nom',
    contact_par_defaut: 'Contact par défaut',
    contacts: 'Contacts',
    trigger_suivi: 'Date de suivi',
    notes: 'Notes',
    pct_commission_defaut: 'Commission par défaut (%)',
    adresse_calcul_km: 'Adresse pour calcul de kilométrage',
    avis_nb_participants: 'Avis à inclure au moment de la confirmation du nb. de part.',
    fk_methode_paiement: 'Méthode de paiement',
    methode_paiement: 'Méthode de paiement',
    nom_acces_d: 'Nom dans AccesD',
    activiteProduits: 'Produits associés',
    fk_id_type_activite: 'Type',
    typeActivite: 'Type',
    minimum_facturable_nombre: 'Minimum facturable nombre',
    minimum_facturable_type: 'Minimum facturable type',
    minimum_facturable_texte: 'Minimum facturable avis',
    max_participants: 'Maximum de participant nombre',
    max_participants_type: 'Maximum de participant type',
    max_participants_texte: 'Maximum de participant texte',
    max_participants_visible: `Maximum de participant visible`,
    periode_ouverture: `Période d'ouverture`,
    tarifs_estimes: 'Tarifs estimés',
    alerte: 'Avis public',
    etiquettes: 'Étiquette(s)',
    fichiers: 'Fichiers',
    fk_id_image_principale: 'Image principale',
    description: 'Description',
    covid: 'Covid',
    covid_description: ' Description covid',
    thematiques: 'Thématiques',
    lieux: 'Lieux',
    guide_type_accueil: `Type d'accueil`,
    guide_creation_horaire: `Création d'horaire`,
    public_cible: 'Public cible',
    guide_minimum_facturable_jour_anim_client: `Min. fact. jour de l'animation (pour client)`,
    guide_minimum_facturable_jour_anim_fournisseur: `Min. fact. jour de l'animation (du fournisseur) INTERNE`,
    temps_avance_animateur: 'Temps en avance des animateurs',
    ratio_groupe: 'Ratio et formation de groupe',
    locaux: 'Locaux',
    langues: 'Langues',
    guide_changement_prix: 'Changement de prix',
    horaire_type: 'Horaire type',
    guide_preparation: 'Comment bien vous préparer à l’activité',
    questionnaire_logistique: 'Questionnaire logistique',
    guide_clauses_politiques: 'Clauses et politiques',
    guide_FAQ: 'FAQ',
    piece_jointe: 'PDF additionnel',
    annnee_scolaire: 'Année scolaire',
    centre_service_scolaire: 'Centre de Service Scolaire',
    journee: `Date(s)`,
    prefix: 'Préfix',
    courriel: 'Courriel',
    telephone: 'Téléphone',
    fin_abonnement: `Fin d'abonnement`,
    nb_avg_pedago: 'Nombre Moyenne Pédago (par défaut)',
    nb_avg_sortie: 'Nombre Moyenne Sortie',
    nb_sdg_total: 'Nombre SDG Total',
    nb_eleves_total: `Nombre d'élèves Total`,
    nb_groupe_classe: `Nombre de groupe de classe`,
    groupe_age: `Groupe d'âge`,
    grandeur_gym: `Grandeur du gymnase`,
    isAdmin: `Activer les droits administrateur`,
    civilite: 'Civilité',
    nom: 'Nom',
    prenom: 'Prénom',
    email: 'Courriel',
    abbr: 'Abréviation',
    fk_id_region: 'Région',
    link: 'Lien',
    num_fournisseur: 'Numéro de fournisseur',
    b_entente: 'Entente',
    lieu: 'Lieu',
    fk_status_entreprise: 'Statut',
    status_entreprise: 'Statut',
    neq: 'NEQ',
    tps: '# TPS',
    tvq: '# TVQ',
    contact_gestionnaire: 'Gestionnaire',
    debut_relation_date: 'Date de debut de la relation',
    delais_reception_facture: 'Delai de reception de facture en Jour(s)',
    delais_reception_facture_texte: 'Delai de reception de facture Avis',
    adresse: 'Adresse',
    ville: 'Ville',
    province: 'Province',
    code_postal: 'Code Postal',
    region: 'Région',
    role: 'Rôles',
    categorie: 'Catégorie',

    // Ajoutez toutes les autres correspondances nécessaires
};

export type BasePropsDeFormulaireEntite<T extends NouvelleEntite<BaseEntite>> = {
    entite: BaseEntiteStatique<T>;
    badges?: string[] | ((entite: T) => string[]);
    children?: ReactNode;
    succes?: (valeurs: T) => void;
    nettoyer?: (valeurs: T) => void;
    schema?: ObjectSchema<Partial<T>>;
    modal?: boolean;
    onBeforeSave?: (entite: T, helpers: FormikHelpers<T>) => T | void | Promise<T | void>;
    noSave?: boolean;
    actions?: (t: T) => ReactNode;
};

export type PropsDeFormulaireEntite<T extends NouvelleEntite<BaseEntite>> = BasePropsDeFormulaireEntite<T> & {
    valeursInitiales: T;
    soumettreFormulaire: (valeurs: T, helpers: FormikHelpers<T>, initialValues: T) => T | null | Promise<T | null>;
    texteEntete?: ReactNode | ((t: T) => ReactNode);
    sauvegardeEnToutTemps?: boolean;
};

function findDifferences(obj1, obj2) {
    let currentSingleName = '';
    let differences = '';
    // Vérifie si la valeur est un objet (excluant les tableaux)
    const estObjet = (valeur) => valeur && typeof valeur === 'object' && !Array.isArray(valeur);

    // Comparaison des tableaux
    function compareArrays(oldArray: any[], newArray: any[], path: string) {
        // Assurez-vous que stringify retourne une chaîne ou modifiez son type de retour approprié
        const oldMap = new Map<string, any>(oldArray.map((item, index) => [stringify(item, path, index), item]));
        const newMap = new Map<string, any>(newArray.map((item, index) => [stringify(item, path, index), item]));

        const added: string[] = [];
        const removed: string[] = [];

        newMap.forEach((newItem, key) => {
            if (!oldMap.has(key)) added.push(key);
            else {
                if (currentSingleName !== '') {
                    const oldItem = oldMap.get(key);
                    compareRecursively(oldItem, newItem, path, oldItem[currentSingleName]?.name + ' ');
                    currentSingleName = '';
                }
            }
        });

        oldMap.forEach((_, key) => {
            if (!newMap.has(key)) removed.push(key);
        });

        if (added.length > 0 && removed.length > 0) {
            differences += `${path}: ${removed.join(', ')} => ${added.join(', ')}; `;
        } else if (added.length > 0) {
            differences += `${path} - Ajouté(s): ${added.join(', ')}; `;
        } else if (removed.length > 0) {
            differences += `${path} - Retiré(s): ${removed.join(', ')}; `;
        }
    }

    const stringify = (val, key = '', index = 0) => {
        if (val === null) return;
        if (Array.isArray(val)) {
            return val.map((v) => stringify(v)).join(', ');
        } else if (estObjet(val)) {
            // Accède dynamiquement au nom basé sur le singulier du tableau conteneur.
            const singleNameKey = key.slice(0, -1);
            if (val[singleNameKey] && val[singleNameKey].name) {
                currentSingleName = singleNameKey;
                // "details" est utilisé pour la fonction de contact (Directeur, enseignant, ...).
                return val.detail ? val.detail + ' ' + val[singleNameKey].name : val[singleNameKey].name;
            } else if (val[key] && val[key].name) {
                // "ignorer" est utilisé pour la visibilté des champs. Par exemple thématiques et images.
                // "index" est utilsé pour l'ordre. Par exemple l'ordre des images ou thématiques.
                return val.ignorer ? `#${index + 1}. ${val[key].name} (masqué)` : `#${index + 1}. ${val[key].name}`;
            } else if (val.name) {
                if ('est_public' in val) {
                    // "est_public" est utilisé pour la visibilté des champs, c'est comme ignorer. Certaines entités utilise ignorer et d'autre est_public
                    return val.est_public === false ? `${val.name} (masqué)` : val.name;
                } else {
                    return val.name;
                }
            } else if (val.date) {
                // "date" est utilisé pour les calendrier scolaires
                return val.date;
            }

            return 'Objet sans nom';
        }
        return val.toString();
    };

    // Comparaison récursive pour les objets et les tableaux
    const compareRecursively = (oldVal, newVal, path, customName?: string) => {
        // Skip this field if path contains 'fk' or 'id'
        if (path.includes('fk_') || path.includes('.id') || /(\b|_)id(\b|_)/.test(path)) {
            return;
        }
        if (path.startsWith('.')) {
            // Retire le '.' s'il y a un point au debut
            path = path.substring(1);
        }

        if (Array.isArray(oldVal) && Array.isArray(newVal)) {
            compareArrays(oldVal, newVal, path);
        } else if (estObjet(oldVal) && estObjet(newVal)) {
            const allKeys = new Set([...Object.keys(oldVal), ...Object.keys(newVal)]);
            allKeys.forEach((key) => {
                if (key in oldVal && key in newVal) {
                    compareRecursively(oldVal[key], newVal[key], `${path}.${key}`, customName);
                } else if (key in oldVal) {
                    differences +=
                        (customName ?? '') +
                        `${path.length ? path + '.' : ''}${key}: ${stringify(oldVal[key], key)} => absent; `;
                } else {
                    differences +=
                        (customName ?? '') +
                        `${path.length ? path + '.' : ''}${key}: absent => ${stringify(newVal[key], key)}; `;
                }
            });
        } else if (oldVal !== newVal) {
            const displayPath = path.includes('.name') ? path.replace('.name', '') : path;

            if (newVal == '' || newVal == null) {
                differences += (customName ?? '') + `${displayPath} - Retiré(s): ${stringify(oldVal)}; `;
            } else if (oldVal == '' || oldVal == null) {
                differences += (customName ?? '') + `${displayPath} - Ajouté(s): ${stringify(newVal)}; `;
            } else if (path == 'description') {
                differences +=
                    (customName ?? '') + `${displayPath} ${obj1.name}: ${stringify(oldVal)} => ${stringify(newVal)}; `;
            } else {
                differences += (customName ?? '') + `${displayPath}: ${stringify(oldVal)} => ${stringify(newVal)}; `;
            }
        }
    };
    compareRecursively(obj1, obj2, '');

    return differences ? differences.slice(0, -2) : '';
}

export default function FormulaireEntite<T extends NouvelleEntite<BaseEntite>>(
    props: PropsDeFormulaireEntite<T>,
): ReactElement {
    const bsAlert = useAlertDialog();
    const {
        entite,
        valeursInitiales,
        children,
        soumettreFormulaire,
        schema,
        modal,
        succes,
        onBeforeSave,
        sauvegardeEnToutTemps,
        noSave,
    } = props;

    if (valeursInitiales['fin_abonnement'] && typeof valeursInitiales['fin_abonnement'] === 'string') {
        valeursInitiales['fin_abonnement'] = valeursInitiales['fin_abonnement'].split('T')[0];
    }

    const [texteButton, _setTexteButton] = useState<ReactNode>('Sauvegarder');
    const setTexteButton = (texte: ReactNode) => {
        if (_isMounted.current) _setTexteButton(texte);
    };

    const [isBlocking, setIsBlocking] = useState(false);
    const _isMounted = useRef(true);

    usePrompt('Etes vous sur de vouloir quitter la page? Vos changements ne seront pas enregistres.', isBlocking);

    useEffect(() => {
        if (valeursInitiales.name) {
            document.title = `${valeursInitiales.name} - Dashboard`;
        }
        return () => {
            _isMounted.current = false;
        };
    }, []);
    return (
        <Formik
            initialValues={valeursInitiales}
            enableReinitialize={true} //changed
            onSubmit={async (entite, helpers) => {
                // Get data from formik
                setTexteButton(
                    <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        &nbsp;Sauvegarder
                    </>,
                );
                try {
                    let data = entite;
                    if (onBeforeSave) {
                        let result = onBeforeSave(entite, helpers);
                        if (result instanceof Promise) {
                            result = await result;
                        }
                        data = typeof result == 'undefined' ? data : result;
                    }

                    try {
                        if (data['id']) {
                            let copyVI = { ...valeursInitiales };
                            copyVI['date_activite'] = valeursInitiales['date_activite']
                                ? valeursInitiales['date_activite'].split('T')[0]
                                : null;
                            data['date_activite'] = data['date_activite'] ? data['date_activite'].split('T')[0] : null;
                            if ('image_principale' in data) {
                                copyVI['image_principale'] = ((valeursInitiales as unknown) as Activite).fichiers.find(
                                    (file) =>
                                        file.fk_id_fichier ===
                                        ((valeursInitiales as unknown) as Activite).fk_id_image_principale,
                                )?.fichiers.name;
                            }
                            if (!noSave) {
                                let dataToLog = findDifferences(copyVI, data);
                                dataToLog = transformerNomsDesChamps(dataToLog, champCorrespondance);
                                let user = await api.get('/historique_logs/user/session');
                                let date = new Date();
                                let datestring =
                                    date.getFullYear() +
                                    '-' +
                                    (date.getMonth() + 1) +
                                    '-' +
                                    date.getDate() +
                                    ' ' +
                                    date.getHours() +
                                    ':' +
                                    date.getMinutes() +
                                    ':' +
                                    date.getSeconds();

                                const logData = {
                                    nom_table: nomDeTable[props.entite.key],
                                    name: '',
                                    id_element: data['id'],
                                    nom_usager: user.data.name,
                                    api_body: dataToLog, // Make sure to stringify if it's an object
                                    date_modification: datestring, // Get the current time in ISO format
                                };
                                const reponse = await api.post('/historique_logs', logData);
                            }
                        }
                    } catch (error) {
                        console.error("Erreur lors de l'enregistrement de l'historique:", error);
                        // Affichage d'un avertissement mais on continue la soumission
                        bsAlert(
                            "Avertissement: La modification a été enregistrée, mais l'enregistrement dans l'historique a échoué.",
                            'warning',
                        );
                    }
                    let result = soumettreFormulaire({ ...data, ...schema?.cast(data) }, helpers, valeursInitiales);
                    if (result instanceof Promise) {
                        result = await result;
                    }

                    setTexteButton(
                        <>
                            <BiCheck />
                            &nbsp;Sauvegardé
                        </>,
                    );
                    setTimeout(() => setTexteButton('Sauvegarder'), 3000);

                    helpers.resetForm({ values: data });

                    if (succes && result) {
                        succes(result);
                    }
                } catch (error) {
                    console.error(error);
                    const e = error as { message: string; response: { statusText: string } };
                    bsAlert(
                        `Erreur dans l'enregistrement des données: ${e.message} : ${
                            e.response?.statusText ?? 'raison inconnue'
                        }`,
                        'danger',
                    );
                    setTexteButton(
                        <>
                            <BiError />
                            &nbsp;Erreur
                        </>,
                    );
                    setTimeout(() => setTexteButton('Sauvegarder'), 3000);
                }
            }}
            validationSchema={schema}
        >
            {(formik: FormikProps<T>) => {
                const { handleSubmit, values, errors, touched } = formik;
                const badges: string[] =
                    (typeof props.badges === 'function' ? props.badges(values) : props.badges) ?? [];
                const texteEntete =
                    typeof props.texteEntete === 'function' ? props.texteEntete(values) : props.texteEntete;

                const body = (
                    <>
                        {badges.map((contenu, index) => (
                            <span key={index}>
                                <Badge variant="light" className="my-2 bg-white shadow-sm p-2">
                                    {contenu}
                                </Badge>{' '}
                            </span>
                        ))}
                        <fieldset>{children}</fieldset>
                    </>
                );

                const bouton = (
                    <Button type="submit" variant="primary" className="d-flex align-items-center">
                        {texteButton}
                    </Button>
                );

                const cssEntete: CSSProperties = {
                    top: 54,
                    zIndex: 2,
                    margin: '0px -15px',
                    padding: '10px 15px',
                };

                return (
                    <div style={modal ? { height: '100%', minHeight: '80vh' } : { marginTop: -16 }}>
                        <Form
                            className={modal ? 'h-100 d-flex flex-column' : ''}
                            noValidate
                            onChange={(e) => {
                                setIsBlocking((e.target as HTMLFormElement).value.length > 0);
                            }}
                            onSubmit={(e) => {
                                handleSubmit(e as FormEvent<HTMLFormElement>);
                                setIsBlocking(false);
                            }}
                        >
                            {modal ? (
                                <>
                                    <Modal.Header closeButton>
                                        <Modal.Title>{texteEntete ?? (values as T).name}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>{body}</Modal.Body>
                                    <Modal.Footer>{bouton}</Modal.Footer>
                                </>
                            ) : (
                                <>
                                    <div
                                        className="position-sticky bg-white d-flex justify-content-between align-items-center shadow-sm"
                                        style={cssEntete}
                                    >
                                        <div>
                                            <EnteteDePage texte={texteEntete ?? (values as T).name} />
                                        </div>
                                        <div className="d-flex">
                                            <BoutonPreSuiv />
                                            <ButtonGroup className="align-items-center">
                                                {props.actions ? (
                                                    <>
                                                        <Form.Group className="mb-0">
                                                            <DropdownButton
                                                                variant="outline-secondary"
                                                                title="Actions"
                                                                className="mr-2"
                                                            >
                                                                {props.actions(values)}
                                                            </DropdownButton>
                                                        </Form.Group>
                                                    </>
                                                ) : null}
                                                <Form.Group className="mb-0">{bouton}</Form.Group>
                                            </ButtonGroup>
                                        </div>
                                    </div>
                                    <div className="bg-light w-100 h-100 fixed-top z-index-n1"></div>
                                    {body}
                                </>
                            )}
                        </Form>
                    </div>
                );
            }}
        </Formik>
    );
}
